import { render, staticRenderFns } from "./MarinaIndustrySponsoredCadets2021.vue?vue&type=template&id=4041b471&scoped=true"
import script from "./MarinaIndustrySponsoredCadets2021.vue?vue&type=script&lang=js"
export * from "./MarinaIndustrySponsoredCadets2021.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4041b471",
  null
  
)

export default component.exports